import { inject, Injectable } from '@angular/core';
import { StateContext } from '@ngxs/store';
import { TableStateModel } from '../table.state.model';
import { Pagination } from '@core/models/pagination.model';
import { TableActions } from '../table.actions';
import { PartnerService } from '@core/services/partner.service';
import { NotificationFacade } from '@core/facades/notification.facade';

@Injectable({
  providedIn: 'root',
})
export class PartnersHandler {
  partnerService = inject(PartnerService);
  notify = inject(NotificationFacade);

  handlePartnersLoad(ctx: StateContext<TableStateModel>, params: Pagination) {
    this.partnerService.getPartners({ ...params }).subscribe({
      next: (response) => {
        ctx.dispatch(
          new TableActions.LoadTableDataSuccess({
            tableKey: 'partners',
            data: response.data?.data,
            totalCount: response.data?.total_count,
          })
        );
      },
      error: (error) => {
        ctx.dispatch(
          new TableActions.LoadTableDataFailure({
            tableKey: 'partners',
            error: error.message,
          })
        );
      },
    });
  }

  filterPartnersList(
    ctx: StateContext<TableStateModel>,
    action: TableActions.FilterPartnersList
  ) {
    return this.partnerService
      .getPartners(undefined, action.payload.filter)
      .subscribe({
        next: (response) => {
          ctx.dispatch(
            new TableActions.LoadTableDataSuccess({
              tableKey: 'partners',
              data: response.data?.data,
              totalCount: response.data?.total_count,
            })
          );
        },
        error: (error) => {
          ctx.dispatch(
            new TableActions.LoadTableDataFailure({
              tableKey: 'partners',
              error: error.message,
            })
          );
        },
      });
  }

  deletePartner(
    ctx: StateContext<TableStateModel>,
    action: TableActions.DeletePartner
  ) {
    return this.partnerService
      .deletePartner(action.payload.partnerId)
      .subscribe({
        next: () => {
          const state = ctx.getState();
          const partners = state.partners?.data.filter(
            (partner) => partner.id !== action.payload.partnerId
          );

          ctx.patchState({
            partners: {
              ...state.partners,
              data: partners,
              totalCount: Math.max((state.partners?.totalCount ?? 1) - 1, 0),
            },
          } as Partial<TableStateModel>);

          this.notify.success('Partner deleted successfully');
        },
        error: () => {
          this.notify.error('Failed to delete partner');
        },
      });
  }
}
